import { DefaultRootState } from 'react-redux';
import { action, props } from 'ts-action';

export interface SkipHistory {
  meta: { history: false };
}

export interface OptionalHistory {
  meta?: { history: boolean };
}

export interface StateDiff {
  toPrevious: Partial<DefaultRootState>;
  toNext: Partial<DefaultRootState>;
}

export interface Undo {
  diff: Partial<DefaultRootState>;
}

export const saveUndoState = action(
  '[Undo] saveUndoState - blacklisted',
  props<StateDiff & SkipHistory>(),
);

export const undo = action('[Undo] undo', props<Undo & SkipHistory>());

export const restore = action('[Undo] restore', props<Undo & SkipHistory>());
